import React,{useState} from 'react'
import { FormControl, FormHelperText, Box, Select,Grid} from '@mui/material';

import { getTzOffsetSeconds, getTZoffesetFromTZ } from '../../Helper/timeHelpers';
import { createTzRange } from '../../Helper/timeHelpers';

interface DateProps{
    title:string,
    startHandler:SelectHandler,
    endHandler:SelectHandler,
    startValue:number,
    endValue:number,
    timezone:string,
    
}
export interface SelectHandler{
    (event:React.ChangeEvent<HTMLInputElement>): void
}

const optionText = (option:number|string)=>{
    return(option.toString())
  }
function valuetext(value:number) {
    return new Date(value).toISOString().slice(0, -1)
}
function DateForm(props:DateProps){
    const {title, startHandler, startValue,endHandler, endValue, timezone} = props
    //const [tz, setTz] = useState(new Date().getTimezoneOffset()*60*1000)
    //const tz = getTzOffsetSeconds(timezone)*1000
    //const tz = getTZoffesetFromTZ(timezone)*1000
    //const startString = new Date(startValue+tz).toISOString().slice(0, -8)
    //const endString = new Date(endValue+tz).toISOString().slice(0, -8)
    const startString = new Date(startValue).toISOString().slice(0, -8)
    const endString = new Date(endValue).toISOString().slice(0, -8)
   
    //console.log(tz)
    const SelectLabelId = `${title}-select-datetime-label`
    const SelectId = `${title}-datetime-small`
    const tzOptions= createTzRange()
    //console.log(tzOptions)
    //console.log(`Inside Date From\n raw start date is ${startValue}: ${new Date(startValue).toISOString()}`)
    //console.log(`Inside Date From\n raw end date is ${endValue}: ${new Date(endValue).toISOString()}`)
    //console.log(`got timezone offset of:${tz}seconds`)
    //console.log("start time string:", startString)
    //console.log("end time string:",endString)
    return(
        <Box>
        <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
                <FormControl sx={{ m: 1, minWidth: 140, px:5 }}>
                    <FormHelperText sx={{color: 'white'}}>{title}</FormHelperText>
                    <input name="Start-Picker" aria-label="Date and time" type="datetime-local" onChange={startHandler} value={startString}/>
                    <input name="End-Picker" aria-label="Date and time" type="datetime-local" onChange={endHandler} value={endString}/>
                </FormControl>        
            </Grid>
        </Grid>
        </Box>
       
    )
}

export default DateForm